<template>
	<div class="detail">
		<div class="answer">
			<div class="answer1">
				<span class="label">答案 </span>
				<span class="answer_item" v-for="item in answer">{{aipchOptions[item]}}</span>
			</div>
			<div class="answer2" :style="{color:isRight?'#3964E6':'#F63F33'}">
				<span class="label">您选择</span>
				<span class="answer_item" v-for="item in youAnswer">{{aipchOptions[item]}}</span>
			</div>
		</div>
		<div class="analysis">
			<div class="title">
				<span class="line"></span>
				<span>{{title}}</span>
			</div>
			<div class="content">{{content?content:'暂无问题解析'}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			answer:{
				type:Array,
				default:()=>{
					return []
				}
			},
			youAnswer:{
				type:Array,
				default:()=>{
					return []
				}
			},
			isRight:{
				type:Boolean,
				default:true
			},
			content:{
				type:String,
				default:'暂无问题解析'
			},
			title:{
				type:String,
				default:'答案解析'
			}
		},
		data(){
			return {
				aipchOptions:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'],
			}
		}
	}
</script>

<style scoped lang="scss">
	.answer{
		display: flex;
		padding: 20px 34px;
		background: #F2F6F9;
		border-radius: 4px;
		.answer1{
			margin-right: 26px;
			color: #3964E6;
		}
		.label{
			padding-right:31px;
			color:#000;
		}
	}
	.analysis{
		display: none;
		margin-top: 63px;
		.title{
			display: flex;
			align-items: center;
			font-size: 38px;
			font-weight: bold;
			color: #333333;
			line-height: 1;
			margin-bottom: 25px;
			.line{
				width: 6px;
				height: 48px;
				background: #3964E6;
				border-radius: 3px;
				margin-right: 20px;
				display: inline-block;
			}
		}
		.content{
			color: #666666;
			span-indent: 2em;
		}
	}
</style>
